import { default as folderTreeViewStateStore } from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import setFolderViewState from '../actions/setFolderViewState';
export default select({
    folderNodeViewStates: function () { return folderTreeViewStateStore.folderNodeViewStates; },
})(function getFolderViewStateFromId(folderId, state) {
    var viewState = state.folderNodeViewStates.get(folderId);
    if (!viewState) {
        viewState = {
            isExpanded: false,
            drag: createDragViewState(),
            drop: createDropViewState(),
        };
        setFolderViewState(folderId, viewState);
    }
    return viewState;
});
//# sourceMappingURL=getFolderViewStateFromId.js.map